const strings = {
    loginPage: {
        buttons: {
            login: 'LOGIN',
            remindPass: 'Forgot password?',
        },
        labels: {
            email: 'E-mail adress',
            password: 'Password',
        },
        title: 'Login',
        header: 'Change the world with Marek',
        errorMessage: 'Wrong email or password.',
    },
    sidebar: {
        adminSettings: ['Users', 'Item List', 'Chargeable products'],
        sectionTitle: 'Admin settings',
        sidebarInfo: [
            'Knowledge',
            'News and Events',
            'Courses',
            'Additional missions',
            'App users',
            'Rewards',
            'Documents',
            'About me',
            'Chat',
            'Meetings',
            'Chat Schedule',
        ],
        sidebarLogout: 'Log out',
    },
    addFiles: {
        text: 'Drag and drop files here',
        text2: 'JPG or PNG, file size no more than',
        button1: 'Select file',
        button2: 'Send file',
        loading: 'Loading',
        errorMessage: 'Error! Try again.',
        pdfContent: 'PDF, file size no more than',
        successMessage: 'Sended!',
        acceptedFormat: 'image/*',
    },
    resetPasswordPage: {
        buttons: {
            continue: 'CONTINUE',
        },
        labels: {
            email: 'E-mail adress',
        },
        title: 'Reset your password',
        secondScreen: {
            title: 'Check your email to reset your password.',
            subTitle:
                'If there’s an account associated with your email  you’ll get a link in your inbox to reset your password.',
        },
    },
    newsAndEvents: {
        title: 'Add title',
        image: 'Add image',
        file: 'Add file',
        text: 'Add text',
        dateFrom: 'Date from',
        dateTo: 'Date to',
        successSave: 'Event saved',
        successPublish: 'Event published',
        buttons: {
            delete: 'Delete',
            save: 'Save',
            saveNote: 'Save note',
            publish: 'Publish',
        },
    },
    knowledge: {
        title: 'Knowledge',
        placeholderTitle: ' title',
        placeholderAuthor: ' author',
        placeholderLink: 'Link',
        labelTitle: 'Recommendation',
    },
    confirmDialog: {
        title: 'Confirm action',
        text: 'Are you sure that you want to perform this action?',
        buttons: {
            no: 'No',
            yes: 'Yes',
        },
    },
    usersPage: {
        errors: {
            getUsers: "Could't load data",
            deleteUser: 'Something went wrong during deleting user action',
            addUser: 'Something went wrong during adding user action',
            editUser: 'Something went wrong during editing user action',
            sendNotification: 'Something went wrong during sending notification',
        },
    },
    chatSchedulePage: {
        errors: {
            addError: 'Something went wrong during adding schedule',
            deleteError: 'Something went wrong during deleting schedule',
            updateError: 'Something went wrong during updating schedule',
            getError: 'Something went wrong during getting schedules',
        },
        successMessage: 'Data has been saved successfully.',
        selectDate: 'Please select date',
        editSchedule: {
            hour: 'Hour',
            minute: 'Minute',
            startTime: 'Start time',
            endTime: 'End time',
            save: 'Save time period',
            cancel: 'Cancel',
        },
        scheduleList: {
            startTimeEarlier: 'Start time must be earlier than end time',
            periodConflict: 'There is already schedule defined for selected hours',
            pastError: "Can't add time period in the past",
            add: 'Add time period',
            delete: 'Delete',
            edit: 'Edit time period',
            success: 'Operation successful',
        },
    },
    coachPage: {
        errors: {
            addCoachInfo: 'Something went wrong during add info action',
            getCoach: "Could't load data",
            getMeetings: "Could't load meetings",
            updateAvailableTimeCoach: 'Something went wrong during updating coach available time',
            fetchMeetings: 'Something went wrong during fetching meetings',
            errorPhoneNumber: 'Please enter a valid phone number',
        },
        successMessage: 'Data has been saved successfully.',
        meetings: {
            successMessage: 'New time slots has been saved successfully.',
            successMessageSaveNote: 'Note has been saved successfully saved.',
            notesLabel: 'Live your notes',
            title: 'Meetings',
            new: 'Set available time slots',
            confirmed: 'Confirmed meetings',
            cancelled: 'Cancelled meetings',
            noCoachNotification:
                'Please fill out your information in the "About me" section in order to be able to schedule meetings.',
            maxLengthNote: 'Max note length 2000 characters.',
        },
        chat: {
            noActiveConverastion: "You don't have active conversation. You can't send message.",
        },
    },
    productsPage: {
        productsTitle: 'Select product type',
        productSelectLabel: 'Products',
        meetings: {
            meetingsArePaid: 'Meetings are paid',
            meetingsAreFree: 'Meetings are free',
        },
        table: {
            price: 'Price, PLN',
            paid: 'Paid',
            free: 'Free',
            costOfMeeting: 'Provide cost for meeting',
        },
        tableProductHeader: {
            meeting: 'Meeting time',
            course: 'Course title',
            article: 'Article title',
            video: 'Video title',
        },
        saveSuccessMessage: 'Data has been saved successfully',
        saveErrorMessage: "Could't load data",
        priceError: 'The price should be 0 or more.',
        searchLabelByTitle: 'Search by title',
    },
    missions: {
        missionsTitle: 'Courses',
        stagesTitle: 'Chapters',
        exercisesTitle: 'Lesson',
        addMissionDialog: {
            skillsLabel: 'SKILLS',
            surveyDifferentLabel: 'ENTRY SURVEY DIFFERENT FROM EXIT SURVEY',
            maxTitleLength: 'Maximum title length 25 characters.',
        },
        addStageDialog: {
            firstScreenLabel: 'First screen',
        },
        addExerciseDialog: {
            skillsLabel: 'SKILLS',
            badgeLabel: 'BADGE',
            renewalPercentage: 'RENEWAL PERCENTAGE',
            backpack: 'BACKPACK',
            visibleSavedExercises: 'VISIBLE SAVED EXERCISES IN BACKPACK',
        },
        stageZero: {
            surveyLabel: 'Survey',
        },
        stageExitSurvey: {
            entrySurvey: 'Entry survey',
            exitSurvey: 'Exit survey',
        },
    },
    additionalMissions: {
        missionsTitle: 'Additional Missions',
        stagesTitle: 'Chapters',
        exercisesTitle: 'Lesson',
        addMissionDialog: {
            skillsLabel: 'COURSE',
        },
        addStageDialog: {
            firstScreenLabel: 'First screen',
        },
        addExerciseDialog: {
            skillsLabel: 'COURSE',
            proficienciesLabel: 'PROFICIENCIES',
            renewalPercentage: 'RENEWAL PERCENTAGE',
            backpack: 'BACKPACK',
        },
        stageZero: {
            surveyLabel: 'Survey',
        },
    },
    tasks: {
        taskLabel: 'Step',
        addTaskBtnLabel: 'Add step',
        addImgBtnLabel: 'Add image',
        addPlateBtnLabel: 'Add plate',
        successMessage: 'Data has been saved successfully.',
    },
    rewards: {
        title: 'Rewards',
        namePlaceholder: 'Title',
    },
    languagesValidation: {
        errorMessage: 'Form is not valid. Check if every language is filled.',
    },
    urlValidation: {
        errorUrlMessage: 'Form is not valid. Check if link is correct.',
    },
    documents: {
        title: 'Documents',
    },
    exportStatistics: {
        buttonTitle: 'Export',
    },
};

export default strings;
